import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AttachedPositionItem } from "@ServerTypes/orgUnits/orgUnits.schema";

const projectAttachedPositionSlice = createSlice({
  name: "projectAttachedPosition",
  initialState: [] as AttachedPositionItem[],
  reducers: {
    setProjectAttachedPosition: (_state: AttachedPositionItem[], action: PayloadAction<AttachedPositionItem[]>) =>
      action.payload,
  },
});

export const { setProjectAttachedPosition } = projectAttachedPositionSlice.actions;

export const projectAttachedPosition = projectAttachedPositionSlice.reducer;
